import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import BannerDetail from './components/BannerDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageBanner',
  components: {
    BannerDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;